@let blok = block();

@if (blok.closeable) {
    <section WLTempBorder
             [attr.id]="blok.sectionId?.length ? blok.sectionId : null"
             [ngClass]="getAllClasses()"
             [ngStyle]="blok.backgroundImage?.length ? {'background-image': 'url('+ blok.backgroundImage![0].filename +')'} : {}"
             class="w-full relative" (click)="toggleHelpMenu()"
             (keyup)="toggleHelpMenu()" tabindex="0">

        @if (blok.limited) {

            <div WLTempBorder
                 class="max-w-content-width mx-auto min-h-7">
                <div class="overflow-hidden flex gap-5 justify-center items-center"
                     [@slideInOut]="helpMenuOpen()">
                    <p class="my-4 text-5xl text-center font-bold">
                        {{ blok.closedTextContent }}
                    </p>
                    <app-section-closing-icon [active]="closedIconState()" class="inline" />
                </div>
                <div class="overflow-hidden"
                     [@slideInOut]="helpMenuOpen2()">
                    @for (child of blok.children; track child['_uid']) {
                        <s1-cms-component [blok]="child" />
                    }
                </div>
            </div>
        } @else {
            <app-section-closing-icon class="absolute right-4 top-4"
                                      [active]="closedIconState()" />
            <div class="overflow-hidden" [@slideInOut]="helpMenuOpen()">
                <p class="my-4 text-5xl text-center font-bold">
                    {{ blok.closedTextContent }}
                </p>
            </div>
            <div class="overflow-hidden" [@slideInOut]="helpMenuOpen2()">
                @for (child of blok.children; track child['_uid']) {
                    <s1-cms-component [blok]="child" />
                }</div>
        }
    </section>
} @else {
    <section WLTempBorder
             [attr.id]="blok.sectionId?.length ? blok.sectionId : null"
             [ngClass]="getAllClasses()"
             [ngStyle]="blok.backgroundImage?.length ? {'background-image': 'url('+ blok.backgroundImage![0].filename +')'} : {}"
             class="w-full">
        @if (blok.limited) {
            <div WLTempBorder class="max-w-content-width mx-auto">
                @for (child of blok.children; track child['_uid']) {
                    <s1-cms-component [blok]="child" />
                }
            </div>
        } @else {
            @for (child of blok.children; track child['_uid']) {
                <s1-cms-component [blok]="child" />
            }
        }
    </section>
}

